import * as participantRepo from "../repositories/participant";

export async function getLastBusinessDate() {
  return participantRepo.get("/last-business-date");
}
